import React from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';
import ReactPlayer from 'react-player';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import HtmlParser from 'html-react-parser';
import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed';
import JoinHappyCustomers from '../../components/JoinHappyCustomers';
import { Link } from 'react-scroll'
import { DemoFormContactus } from '../../components/DemoFormContactus.jsx';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import MultimedialPanel from '../../components/MultimedialPanel';
import FeaturedPress from '../../components/FeaturedPress.js';
import Testimonials from  '../../components/Testimonials.js';
import { PATHS } from '../../utils/urls';


const Home = (props) => {
	const location = props.location;

	return (
		<Layout bodyClass="page-home-index2" ontouchstart>
			<SEO title="Contact Us | ChartHop | People Analytics, Visualized" />
			<Helmet>
				<meta name="description" content="Improve organizational health, drive alignment and accountability, and save time and money - in one central hub, no spreadsheets needed."/>
				<meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
				<meta property="og:title" content="Contact Us | ChartHop | People Analytics, Visualized" />
				<meta property="og:description" content="Improve organizational health, drive alignment and accountability, and save time and money - in one central hub, no spreadsheets needed." />
				<meta property="og:image" content={`https://www.charthop.com/home/visualized.png`} />
				<meta property="og:type" content="website" />
				<meta property="og:locale" content="en_US" />
				<meta property="og:site_name" content="ChartHop" />
				<meta name="facebook-domain-verification" content="0773zjfi2h4cnhzn3lybdhl2ntcki6" />
				{/* Twitter Card tags */}
				<meta name="twitter:title" content="Contact Us | ChartHop | People Analytics, Visualized" />
				<meta name="twitter:description" content="Improve organizational health, drive alignment and accountability, and save time and money - in one central hub, no spreadsheets needed." />
				<meta name="twitter:image" content={`https://www.charthop.com/home/visualized.png`} />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@charthop" />
				<meta name="twitter:creator" content="@charthop" />
			</Helmet>
			<section className="contactus intro container">
				<div className="row contactus-container">
					<div className="space-right-desktop col-md-5 p-xs-2 mb-3 mb-md-0 pr-md-2 pr-lg-4">
						<h1 className="contactus-title">Let's Connect!</h1>
						<p className="contactus-subtitle">Submit your message below to chat with us and discover how ChartHop can help you improve organizational health, drive alignment and accountability, and save time and money.</p>	
						<div className="contactus-request-demo">
							<DemoFormContactus source={"company-about-chatwithus-header"} />
						</div>
					</div>
					<div className="reactPlayerContainer col-md-7 col-lg-7 order-md-1" >
						<img src="/img/hero_image.png" alt="hero" title="hero"/>
					</div>
				</div>
			</section>

			{/* CUSTOMERS */}
			<section className="customer testimonial-container pt-8 pb-5 ">
				<JoinHappyCustomers title={HtmlParser('Join our <span class="blue-text">hoppy</span> customers')}></JoinHappyCustomers>
			</section >	
			
			{/* THE SOLUTION */}
			<section className="the-solution">
				<div className="container pt-3 pt-md-5 pb-5  ">

					{/* ANCHORS */}
					<div className="row align-items-center mb-2 mb-md-5 mb-lg-5">
						<div className="col-md-12 text-center">
							<div className="d-flex justify-content-between justify-content-sm-center">
								<Link to="Improve" smooth={true} offset={-70} duration={500} className="inline-anchor smoothScrollLink">Improve org health</Link>
								<Link to="Align" smooth={true} offset={-70} duration={500} className="inline-anchor smoothScrollLink">Drive alignment & accountability</Link>
								<Link to="Save" smooth={true} offset={-70} duration={500} className="inline-anchor smoothScrollLink">Save time & money</Link>
							</div>
						</div>
					</div>

					{/* CENTRALIZE */}
					<div name="Improve" id="Improve" className="contentBlock">
						<MultimedialPanel 
							multimediaPosition="left"
							title="Improve org health"
							uniqeTitle={true}
							link="/product/2105-refresh/org-chart.png"
							type="image"
							paddingClass="padding-top-video-1"
							content={
								<React.Fragment>
									<p className="multimediaDescription">Grow your organization intentionally by monitoring key metrics like employee engagement and pay gaps.</p>
									<p className="multimediaDescription">Increase employee engagement through transparency and better communication.</p>
								</React.Fragment>
							}
						/>
					</div>

					{/* VISUALIZE */}
					<div name="Align" id="Align" className="contentBlock">
						<MultimedialPanel 
							multimediaPosition="right"
							title="Drive alignment and accountability"
							uniqeTitle={true}
							link="/product/2105-refresh/reports.png"
							type="image"
							paddingClass="padding-top-video-2"
							content={
								<React.Fragment>
									<p className="multimediaDescription">Unlock critical insight for everyone from executives and managers to employees, relying on built-in access controls to protect sensitive data.</p>
									<p className="multimediaDescription">Measure the effectiveness of DEI programs and easily identify gaps.</p>
								</React.Fragment>
							}
						/>
					</div>

					{/* SAVE */}
					<div name="Save" id="Save" className="contentBlock">
						<MultimedialPanel 
							multimediaPosition="left"
							title="Save time and money"
							uniqeTitle={true}
							link="/product/people-analytics/Integration_reports-2.mp4"
							type="video"
							paddingClass="padding-top-video-3"
							content={
								<React.Fragment>
									<p className="multimediaDescription">Streamline processes and data, without additional headcount by saying goodbye to spreadsheets.</p> 
									<p className="multimediaDescription">Reduce attrition by identifying risks early.</p>
								</React.Fragment>
							}
						/>
					</div>

				</div>
			</section>

			{/* AS FEATURED IN */}

			<FeaturedPress bgGrey backgroundGradientContainer />

			<Testimonials />

			{/* REQUEST DEMO */}
			<section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
				<DemoFormLong source={"company-about-chatwithus-bottom"} centerContent={true} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-3 contact-testimonial-index2">"Planning and managing organizations, people growth and modeling org changes has been mostly manual until now - ChartHop makes it all happen in software."</p><div class="authorTag"><img src="/supporters/aileen-cowboy.png" class="testimonialAuthor" alt="Aileen Lee from Cowboy" /><div><p class="contactAuthor"><strong>Aileen Lee</strong> <br>Founder & Partner, Cowboy Ventures</p></div></div>')}/>
			</section>
		</Layout>
	);
};


export default Home;